import React from 'react';
import Icon  from '../ui/Icon';
import Avatar from '../ui/Avatar';
import NotificationBell from '../ui/NotificationBell';
import { useAuth } from '../../context/AuthContext';
import { useApp }  from '../../context/AppContext';
import logo from '../../assets/logo.png';

const TopBar = ({ title, showMenu = true, showBell = true }) => {
  const { user }    = useAuth();
  const { openMenu } = useApp();

  return (
    <header className="flex-shrink-0 h-[62px] flex items-center justify-between px-5 bg-surface-800/90 backdrop-blur-xl border-b border-surface-500 relative z-10">
      {showMenu ? (
        <button
          onClick={openMenu}
          className="w-9 h-9 rounded-xl bg-surface-700 flex items-center justify-center text-surface-200 hover:text-slate-800 hover:bg-surface-500 transition-colors press-scale"
        >
          <Icon name="menu" size={18} />
        </button>
      ) : (
        <div className="w-9" />
      )}

      <div className="flex items-center gap-2">
        <img src={logo} alt="HostAssist" className="w-10 h-10 object-contain" />
      </div>

      {showBell ? (
        <div className="flex items-center gap-2">
          <NotificationBell />
        </div>
      ) : (
        <Avatar initials={user?.avatar || 'AK'} size="sm" />
      )}
    </header>
  );
};

export default TopBar;
